import axios from 'axios';
import qs from 'qs';
import * as cyDetect from '@cy/detect';

/**
 * error_code值枚举
 * 0 正常
 * 1 业务错误
 * 2 请求过程中出错
 * 3 响应过程中出错
 */

const service = axios.create({
  withCredentials: true, // 是否允许跨域
  // 请求头
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=utf-8',
    'X-Requested-With': 'XMLHttpRequest',
  },
  // 在向服务器发送请求前，序列化请求数据
  transformRequest: [
    function(data) {
      return qs.stringify(data);
    },
  ],
  // 校验状态码，因为业务中需要用catch捕获接口错误，代码写起来比较繁琐，所以这里全部返回Promise.resolve;
  validateStatus() {
    return true;
  },
});
// 请求拦截器
service.interceptors.request.use(
  // 使用正常配置请求
  config => config,
  // 请求出错则将错误抛到业务代码
  error => {
    const { data = {} } = error;
    data.error_code = 2;
    data.error_msg = '请求出错，请稍后再试';
    return Promise.resolve(data);
  }
);
// 响应拦截器
service.interceptors.response.use(
  response => {
    let {
      // eslint-disable-next-line prefer-const
      status,
      data = {
        error_code: 1,
        error_msg: '请求失败，请稍后重试',
      },
    } = response;
    if (status === 401) {
      // 跳转到登录页
      if (cyDetect.isFromCY()) {
        window.location.href = `${window.location.origin}/v-m-mall/app-login/#OPEN_NEW_WIN`;
      } else {
        window.location.href = `${
          window.location.origin
        }/cooperation/wap/quick_login/?next=${encodeURI(window.location.href)}`;
      }
    } else if (status === 403) {
      // 拒绝访问
    } else if (status >= 500) {
      data = {};
      // 服务器错误
      data.error_code = 1;
      data.error_msg = '服务器内部错误，请稍后重试';
    }
    return data;
  },
  // 获取响应出错将错误抛到业务代码
  error => {
    const { data = {} } = error;
    data.error_code = 3;
    data.error_msg = '请求出错，请稍后再试';
    return Promise.resolve(data);
  }
);

export default service;
